import { useSelector } from 'react-redux'

import { useGetRecipeIdsByCoreIds } from 'hooks/menu-recipes/useGetRecipeIdsByCoreIds'
import { useRecipes } from 'hooks/menu-recipes/useRecipes'
import type { Recipe, RecipeCoreId } from 'reducers/menu-recipes/recipes'
import { getBasketRecipesIDs } from 'routes/Menu/selectors/basket'

export type BasketRecipe = {
  coreId: RecipeCoreId
  recipe: Recipe | null // null means recipe is not loaded
}

/**
 * Returns an array of basket recipes with their core IDs and the corresponding recipe objects.
 */
export const useBasketRecipes = (): BasketRecipe[] => {
  const basketRecipeCoreIds = useSelector(getBasketRecipesIDs) as RecipeCoreId[]
  const basketRecipeUUIDs = useGetRecipeIdsByCoreIds(basketRecipeCoreIds)

  const recipes = useRecipes(basketRecipeUUIDs)

  const basketRecipes: BasketRecipe[] = []

  basketRecipeCoreIds.forEach((coreId, index) => {
    const coreIdString = coreId.toString() as RecipeCoreId
    const recipe = recipes[index]
    basketRecipes.push({ coreId: coreIdString, recipe: recipe || null })
  })

  return basketRecipes
}
